import { ReactNode } from 'react';
import styled from 'styled-components';

import { LinkButton } from 'components/Toolkit/Button/LinkButton';
import { media } from 'helpers/breakpoints';
import { useSearchFilterDispatch } from 'components/SearchPage/context/SearchFilterContext';
import { LastSearchCard } from 'components/PageWrappers/SharedComponents/LastSearchCard/LastSearchCard';
import type { TLastSearch } from 'components/PageWrappers/SharedComponents/LastSearchCard/types';

export interface IFiltersPanelProps {
  children: ReactNode;
  lastSearchData?: TLastSearch;
  lastSearchCallback?: () => void;
  showSearch?: boolean;
}

const Header = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.S8};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  border-bottom: 1px solid ${({ theme }) => theme.colors.GREY_LIGHT};

  ${media.large} {
    display: flex;
    justify-content: space-between;
    padding-bottom: ${({ theme }) => theme.spacing.M16};
  }
`;

const Heading = styled.h5`
  ${({ theme }) => theme.fontSize.L24};
`;

const Body = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.L48};
`;

const SLastSearchCard = styled(LastSearchCard)<{ isDisabled: boolean }>`
  padding: ${({ theme }) => `${theme.spacing.S8} ${theme.spacing.S12}`};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  box-shadow: ${({ isDisabled, theme }) =>
    isDisabled ? 'none' : theme.shadow.CONTAINER};
  border-radius: ${({ theme }) => theme.borderRadius.default};
`;

function FiltersPanel({
  children,
  lastSearchData,
  lastSearchCallback,
  showSearch = true,
}: IFiltersPanelProps) {
  const { reset } = useSearchFilterDispatch();
  return (
    <div>
      <Header>
        <Heading>Filters</Heading>
        <div>
          <LinkButton onClick={() => reset()} ofType="SECONDARY">
            Reset All
          </LinkButton>
        </div>
      </Header>
      {showSearch && (
        <SLastSearchCard
          lastSearchData={lastSearchData}
          lastSearchCallback={lastSearchCallback}
          isDisabled={!!!lastSearchData}
          lastSearchDataTrackingValue="last_search_search_page"
        />
      )}
      <Body>{children}</Body>
    </div>
  );
}

export { FiltersPanel };
